import { ThemeSkin, ThemeOptions, } from '@wix/da-react-context/pkg/ThemeContext';
export function getBackgroundVariant(theme, themeSkin) {
    if (theme === void 0) { theme = ThemeOptions.DARK; }
    if (themeSkin === ThemeSkin.GREEN && theme === ThemeOptions.LIGHT) {
        return 'green';
    }
    return theme;
}
//# sourceMappingURL=helpers.js.map